import { FinanceCTACreate, FinanceCTAEdit, FinanceCTAList } from './FinanceCTAs'

export default {
  list: FinanceCTAList,
  create: FinanceCTACreate,
  edit: FinanceCTAEdit,
}
